import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RoleApi } from '../../api/RoleApi';

import type { IDeleteRequest } from '../../../types/IApiTypes';

//To get paginated Roles data
export const getRoles = createAsyncThunk(
  'role/getRoles',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return RoleApi.getRoles(action, thunkAPI.dispatch);
  }
);

//To create a role
export const createRole = createAsyncThunk(
  'role/createRole',
  async (action: { request: any }, thunkAPI) => {
    return RoleApi.createRole(action, thunkAPI.dispatch);
  }
);

//To update a role
export const updateRole = createAsyncThunk(
  'role/updateRole',
  async (action: { request: any }, thunkAPI) => {
    return RoleApi.updateRole(action, thunkAPI.dispatch);
  }
);

//To delete a role
export const deleteRoles = createAsyncThunk(
  'role/deleteRoles',
  async (action: IDeleteRequest, thunkAPI) => {
    return RoleApi.deleteRoles(action, thunkAPI.dispatch);
  }
);

//To get a role details
export const getRoleDetails = createAsyncThunk(
  'role/getRoleDetails',
  async (action: { request: any }, thunkAPI) => {
    return RoleApi.getRoleDetails(action, thunkAPI.dispatch);
  }
);

//To get all roles for user tab - create and update user
export const getAllRoles = createAsyncThunk(
  'role/getAllRoles',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return RoleApi.getRoles(action, thunkAPI.dispatch);
  }
);

const initialState = {
  data: [],
};

const roleSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //To get all Roles and updates the data to state
    builder.addCase(getAllRoles.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        state.data = action.payload.data;
      }
    });
  },
});

export default roleSlice.reducer;
